"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.array.find.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product = require("@nucleo/product");
var _utils2 = require("./utils");
var _excluded = ["product", "performance", "timeslot", "hospitalitySession", "themeQueries"];
var _jsxFileName = "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductIndicator.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_4c1niri6z() {
  var path = "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductIndicator.js";
  var hash = "50b5cbdc424ec7d1722d7e221276698c125de542";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductIndicator.js",
    statementMap: {
      "0": {
        start: {
          line: 23,
          column: 18
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 24
        },
        end: {
          line: 25,
          column: 87
        }
      },
      "2": {
        start: {
          line: 30,
          column: 17
        },
        end: {
          line: 30,
          column: 55
        }
      },
      "3": {
        start: {
          line: 45,
          column: 17
        },
        end: {
          line: 45,
          column: 55
        }
      },
      "4": {
        start: {
          line: 58,
          column: 27
        },
        end: {
          line: 96,
          column: 1
        }
      },
      "5": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 68,
          column: 43
        }
      },
      "6": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 71,
          column: 45
        }
      },
      "7": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 77,
          column: 9
        }
      },
      "8": {
        start: {
          line: 76,
          column: 10
        },
        end: {
          line: 76,
          column: 22
        }
      },
      "9": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 92,
          column: 10
        }
      },
      "10": {
        start: {
          line: 98,
          column: 25
        },
        end: {
          line: 117,
          column: 1
        }
      },
      "11": {
        start: {
          line: 109,
          column: 30
        },
        end: {
          line: 109,
          column: 78
        }
      },
      "12": {
        start: {
          line: 110,
          column: 8
        },
        end: {
          line: 113,
          column: 10
        }
      },
      "13": {
        start: {
          line: 119,
          column: 28
        },
        end: {
          line: 121,
          column: 4
        }
      },
      "14": {
        start: {
          line: 123,
          column: 27
        },
        end: {
          line: 125,
          column: 4
        }
      },
      "15": {
        start: {
          line: 127,
          column: 22
        },
        end: {
          line: 134,
          column: 1
        }
      },
      "16": {
        start: {
          line: 137,
          column: 25
        },
        end: {
          line: 199,
          column: 1
        }
      },
      "17": {
        start: {
          line: 138,
          column: 25
        },
        end: {
          line: 138,
          column: 32
        }
      },
      "18": {
        start: {
          line: 139,
          column: 23
        },
        end: {
          line: 139,
          column: 90
        }
      },
      "19": {
        start: {
          line: 142,
          column: 54
        },
        end: {
          line: 142,
          column: 88
        }
      },
      "20": {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 147,
          column: 27
        }
      },
      "21": {
        start: {
          line: 150,
          column: 2
        },
        end: {
          line: 156,
          column: 3
        }
      },
      "22": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 151,
          column: 46
        }
      },
      "23": {
        start: {
          line: 152,
          column: 9
        },
        end: {
          line: 156,
          column: 3
        }
      },
      "24": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 153,
          column: 43
        }
      },
      "25": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 71
        }
      },
      "26": {
        start: {
          line: 158,
          column: 20
        },
        end: {
          line: 158,
          column: 58
        }
      },
      "27": {
        start: {
          line: 159,
          column: 32
        },
        end: {
          line: 159,
          column: 60
        }
      },
      "28": {
        start: {
          line: 160,
          column: 29
        },
        end: {
          line: 160,
          column: 54
        }
      },
      "29": {
        start: {
          line: 161,
          column: 22
        },
        end: {
          line: 161,
          column: 64
        }
      },
      "30": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 166,
          column: 17
        }
      },
      "31": {
        start: {
          line: 163,
          column: 27
        },
        end: {
          line: 163,
          column: 54
        }
      },
      "32": {
        start: {
          line: 168,
          column: 2
        },
        end: {
          line: 198,
          column: 4
        }
      },
      "33": {
        start: {
          line: 201,
          column: 0
        },
        end: {
          line: 213,
          column: 2
        }
      },
      "34": {
        start: {
          line: 215,
          column: 0
        },
        end: {
          line: 221,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 25,
            column: 15
          },
          end: {
            line: 25,
            column: 16
          }
        },
        loc: {
          start: {
            line: 25,
            column: 24
          },
          end: {
            line: 25,
            column: 87
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 9
          }
        },
        loc: {
          start: {
            line: 30,
            column: 17
          },
          end: {
            line: 30,
            column: 55
          }
        },
        line: 30
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        },
        loc: {
          start: {
            line: 45,
            column: 17
          },
          end: {
            line: 45,
            column: 55
          }
        },
        line: 45
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 64,
            column: 26
          },
          end: {
            line: 64,
            column: 27
          }
        },
        loc: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 68,
            column: 43
          }
        },
        line: 65
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 69,
            column: 15
          },
          end: {
            line: 69,
            column: 16
          }
        },
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 71,
            column: 45
          }
        },
        line: 70
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 9
          }
        },
        loc: {
          start: {
            line: 74,
            column: 48
          },
          end: {
            line: 93,
            column: 7
          }
        },
        line: 74
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 108,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        },
        loc: {
          start: {
            line: 108,
            column: 19
          },
          end: {
            line: 114,
            column: 7
          }
        },
        line: 108
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 137,
            column: 25
          },
          end: {
            line: 137,
            column: 26
          }
        },
        loc: {
          start: {
            line: 137,
            column: 109
          },
          end: {
            line: 199,
            column: 1
          }
        },
        line: 137
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 163,
            column: 20
          },
          end: {
            line: 163,
            column: 21
          }
        },
        loc: {
          start: {
            line: 163,
            column: 27
          },
          end: {
            line: 163,
            column: 54
          }
        },
        line: 163
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 30,
            column: 17
          },
          end: {
            line: 30,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 17
          },
          end: {
            line: 30,
            column: 30
          }
        }, {
          start: {
            line: 30,
            column: 34
          },
          end: {
            line: 30,
            column: 55
          }
        }],
        line: 30
      },
      "1": {
        loc: {
          start: {
            line: 45,
            column: 17
          },
          end: {
            line: 45,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 17
          },
          end: {
            line: 45,
            column: 30
          }
        }, {
          start: {
            line: 45,
            column: 34
          },
          end: {
            line: 45,
            column: 55
          }
        }],
        line: 45
      },
      "2": {
        loc: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 68,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 12
          },
          end: {
            line: 67,
            column: 43
          }
        }, {
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 68,
            column: 43
          }
        }],
        line: 65
      },
      "3": {
        loc: {
          start: {
            line: 66,
            column: 12
          },
          end: {
            line: 67,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 13
          },
          end: {
            line: 66,
            column: 24
          }
        }, {
          start: {
            line: 66,
            column: 28
          },
          end: {
            line: 66,
            column: 49
          }
        }, {
          start: {
            line: 66,
            column: 53
          },
          end: {
            line: 66,
            column: 90
          }
        }, {
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 67,
            column: 43
          }
        }],
        line: 66
      },
      "4": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 71,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 9
          },
          end: {
            line: 70,
            column: 20
          }
        }, {
          start: {
            line: 70,
            column: 24
          },
          end: {
            line: 70,
            column: 45
          }
        }, {
          start: {
            line: 70,
            column: 49
          },
          end: {
            line: 70,
            column: 80
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 45
          }
        }],
        line: 70
      },
      "5": {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 75
      },
      "6": {
        loc: {
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 91,
            column: 15
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 86,
            column: 14
          },
          end: {
            line: 88,
            column: 15
          }
        }, {
          start: {
            line: 89,
            column: 14
          },
          end: {
            line: 91,
            column: 15
          }
        }],
        line: 85
      },
      "7": {
        loc: {
          start: {
            line: 90,
            column: 123
          },
          end: {
            line: 90,
            column: 154
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 123
          },
          end: {
            line: 90,
            column: 143
          }
        }, {
          start: {
            line: 90,
            column: 147
          },
          end: {
            line: 90,
            column: 154
          }
        }],
        line: 90
      },
      "8": {
        loc: {
          start: {
            line: 90,
            column: 159
          },
          end: {
            line: 90,
            column: 190
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 159
          },
          end: {
            line: 90,
            column: 179
          }
        }, {
          start: {
            line: 90,
            column: 183
          },
          end: {
            line: 90,
            column: 190
          }
        }],
        line: 90
      },
      "9": {
        loc: {
          start: {
            line: 109,
            column: 30
          },
          end: {
            line: 109,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 30
          },
          end: {
            line: 109,
            column: 65
          }
        }, {
          start: {
            line: 109,
            column: 69
          },
          end: {
            line: 109,
            column: 78
          }
        }],
        line: 109
      },
      "10": {
        loc: {
          start: {
            line: 142,
            column: 54
          },
          end: {
            line: 142,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 54
          },
          end: {
            line: 142,
            column: 65
          }
        }, {
          start: {
            line: 142,
            column: 69
          },
          end: {
            line: 142,
            column: 77
          }
        }, {
          start: {
            line: 142,
            column: 81
          },
          end: {
            line: 142,
            column: 88
          }
        }],
        line: 142
      },
      "11": {
        loc: {
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 147,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 5
          },
          end: {
            line: 144,
            column: 16
          }
        }, {
          start: {
            line: 144,
            column: 20
          },
          end: {
            line: 144,
            column: 34
          }
        }, {
          start: {
            line: 145,
            column: 5
          },
          end: {
            line: 145,
            column: 13
          }
        }, {
          start: {
            line: 145,
            column: 17
          },
          end: {
            line: 145,
            column: 28
          }
        }, {
          start: {
            line: 146,
            column: 5
          },
          end: {
            line: 146,
            column: 23
          }
        }, {
          start: {
            line: 146,
            column: 27
          },
          end: {
            line: 146,
            column: 48
          }
        }, {
          start: {
            line: 147,
            column: 5
          },
          end: {
            line: 147,
            column: 12
          }
        }, {
          start: {
            line: 147,
            column: 16
          },
          end: {
            line: 147,
            column: 26
          }
        }],
        line: 144
      },
      "12": {
        loc: {
          start: {
            line: 150,
            column: 2
          },
          end: {
            line: 156,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 150,
            column: 2
          },
          end: {
            line: 156,
            column: 3
          }
        }, {
          start: {
            line: 152,
            column: 9
          },
          end: {
            line: 156,
            column: 3
          }
        }],
        line: 150
      },
      "13": {
        loc: {
          start: {
            line: 152,
            column: 9
          },
          end: {
            line: 156,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 152,
            column: 9
          },
          end: {
            line: 156,
            column: 3
          }
        }, {
          start: {
            line: 154,
            column: 9
          },
          end: {
            line: 156,
            column: 3
          }
        }],
        line: 152
      },
      "14": {
        loc: {
          start: {
            line: 155,
            column: 20
          },
          end: {
            line: 155,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 155,
            column: 20
          },
          end: {
            line: 155,
            column: 45
          }
        }, {
          start: {
            line: 155,
            column: 49
          },
          end: {
            line: 155,
            column: 70
          }
        }],
        line: 155
      },
      "15": {
        loc: {
          start: {
            line: 158,
            column: 20
          },
          end: {
            line: 158,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 20
          },
          end: {
            line: 158,
            column: 43
          }
        }, {
          start: {
            line: 158,
            column: 47
          },
          end: {
            line: 158,
            column: 58
          }
        }],
        line: 158
      },
      "16": {
        loc: {
          start: {
            line: 159,
            column: 32
          },
          end: {
            line: 159,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 32
          },
          end: {
            line: 159,
            column: 42
          }
        }, {
          start: {
            line: 159,
            column: 46
          },
          end: {
            line: 159,
            column: 60
          }
        }],
        line: 159
      },
      "17": {
        loc: {
          start: {
            line: 160,
            column: 29
          },
          end: {
            line: 160,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 160,
            column: 29
          },
          end: {
            line: 160,
            column: 39
          }
        }, {
          start: {
            line: 160,
            column: 43
          },
          end: {
            line: 160,
            column: 54
          }
        }],
        line: 160
      },
      "18": {
        loc: {
          start: {
            line: 161,
            column: 22
          },
          end: {
            line: 161,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 22
          },
          end: {
            line: 161,
            column: 32
          }
        }, {
          start: {
            line: 161,
            column: 36
          },
          end: {
            line: 161,
            column: 64
          }
        }],
        line: 161
      },
      "19": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 166,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 55
          }
        }, {
          start: {
            line: 164,
            column: 5
          },
          end: {
            line: 164,
            column: 17
          }
        }, {
          start: {
            line: 164,
            column: 21
          },
          end: {
            line: 164,
            column: 42
          }
        }, {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 15
          }
        }, {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 166,
            column: 17
          }
        }],
        line: 163
      },
      "20": {
        loc: {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 197,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 169,
            column: 5
          },
          end: {
            line: 169,
            column: 18
          }
        }, {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 170,
            column: 24
          }
        }, {
          start: {
            line: 171,
            column: 8
          },
          end: {
            line: 174,
            column: 29
          }
        }, {
          start: {
            line: 176,
            column: 5
          },
          end: {
            line: 176,
            column: 14
          }
        }, {
          start: {
            line: 177,
            column: 6
          },
          end: {
            line: 179,
            column: 25
          }
        }, {
          start: {
            line: 181,
            column: 5
          },
          end: {
            line: 181,
            column: 17
          }
        }, {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 27
          }
        }, {
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 185,
            column: 30
          }
        }, {
          start: {
            line: 187,
            column: 5
          },
          end: {
            line: 187,
            column: 16
          }
        }, {
          start: {
            line: 188,
            column: 6
          },
          end: {
            line: 190,
            column: 27
          }
        }, {
          start: {
            line: 192,
            column: 5
          },
          end: {
            line: 192,
            column: 18
          }
        }, {
          start: {
            line: 193,
            column: 6
          },
          end: {
            line: 195,
            column: 27
          }
        }, {
          start: {
            line: 197,
            column: 4
          },
          end: {
            line: 197,
            column: 8
          }
        }],
        line: 169
      },
      "21": {
        loc: {
          start: {
            line: 172,
            column: 11
          },
          end: {
            line: 172,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 172,
            column: 11
          },
          end: {
            line: 172,
            column: 33
          }
        }, {
          start: {
            line: 172,
            column: 37
          },
          end: {
            line: 172,
            column: 54
          }
        }],
        line: 172
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0],
      "11": [0, 0, 0, 0, 0, 0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0, 0, 0],
      "20": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "21": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "50b5cbdc424ec7d1722d7e221276698c125de542"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_4c1niri6z = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_4c1niri6z();
var Indicator = (cov_4c1niri6z().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(props) {
    cov_4c1niri6z().f[0]++;
    cov_4c1niri6z().s[1]++;
    return "stx-ProductCardIndicator stx-ProductCardIndicator-".concat(props.id);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      box-sizing: border-box;\n      ", "\n      right: ", ";\n      top : ", ";\n      z-index: 3;\n      font-size: ", ";\n      border-radius: ", ";\n      display: inline-flex;\n      line-height: 1;\n      letter-spacing: 1px;\n      text-transform: uppercase;\n      padding: ", ";\n    "])), function (props) {
  cov_4c1niri6z().f[1]++;
  cov_4c1niri6z().s[2]++;
  return (cov_4c1niri6z().b[0][0]++, !props.inline) && (cov_4c1niri6z().b[0][1]++, 'position: absolute;');
}, _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.small, _stylingConstants.default.font.sizeS, _stylingConstants.default.border.radiusSmall, _stylingConstants.default.spacing.xsmall)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      box-sizing: border-box;\n      display: inline-flex;\n      ", "\n      right: ", ";\n      top : ", ";\n      padding: 3px 8px;\n      z-index: 3;\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      border-radius: var(--generalBorderRadius, 12px);\n    "])), function (props) {
  cov_4c1niri6z().f[2]++;
  cov_4c1niri6z().s[3]++;
  return (cov_4c1niri6z().b[1][0]++, !props.inline) && (cov_4c1niri6z().b[1][1]++, 'position: absolute;');
}, _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.small, (0, _lodash.get)(_themeMapper.evolutionTheme, 'typography.caption1.fontSize', '14px'), (0, _lodash.get)(_themeMapper.evolutionTheme, 'typography.caption1.lineHeight', '20px'), (0, _lodash.get)(_themeMapper.evolutionTheme, 'fontWeight.medium', 500)))));
var AdvantageIndicator = (cov_4c1niri6z().s[4]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(Indicator).attrs({
  className: 'stx-AdvantageIndicator'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      background-color: ", ";\n      color: ", ";\n    "])), function (props) {
  cov_4c1niri6z().f[3]++;
  cov_4c1niri6z().s[5]++;
  return props.hasAvailability ? (cov_4c1niri6z().b[2][0]++, (cov_4c1niri6z().b[3][0]++, props.theme) && (cov_4c1niri6z().b[3][1]++, props.theme.advantage) && (cov_4c1niri6z().b[3][2]++, props.theme.advantage.backgroundColor) || (cov_4c1niri6z().b[3][3]++, _stylingConstants.default.color.positive)) : (cov_4c1niri6z().b[2][1]++, _stylingConstants.default.color.SOLD_OUT);
}, function (props) {
  cov_4c1niri6z().f[4]++;
  cov_4c1niri6z().s[6]++;
  return (cov_4c1niri6z().b[4][0]++, props.theme) && (cov_4c1niri6z().b[4][1]++, props.theme.advantage) && (cov_4c1niri6z().b[4][2]++, props.theme.advantage.textColor) || (cov_4c1niri6z().b[4][3]++, _stylingConstants.default.color.baseBackground);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      ", ";\n    "])), function (_ref) {
  var theme = _ref.theme,
    hasAvailability = _ref.hasAvailability,
    inline = _ref.inline;
  cov_4c1niri6z().f[5]++;
  cov_4c1niri6z().s[7]++;
  if (!hasAvailability) {
    cov_4c1niri6z().b[5][0]++;
    cov_4c1niri6z().s[8]++;
    return null;
  } else {
    cov_4c1niri6z().b[5][1]++;
  }
  cov_4c1niri6z().s[9]++;
  return (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n          gap: 6px;\n          color: var(--advantageTextColor, #fff);\n          .g-Icon {\n            color: var(--advantageTextColor, #fff);\n          }\n          ", ";\n        "])), inline ? (cov_4c1niri6z().b[6][0]++, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n                background-color: var(--advantageLabelBgColor, #0c6584);\n              "])))) : (cov_4c1niri6z().b[6][1]++, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n                background: linear-gradient(var(--advantageLabelBgColor), var(--advantageLabelBgColor)), linear-gradient(", ", ", ");\n              "])), (cov_4c1niri6z().b[7][0]++, theme.contentBgColor) || (cov_4c1niri6z().b[7][1]++, 'white'), (cov_4c1niri6z().b[8][0]++, theme.contentBgColor) || (cov_4c1niri6z().b[8][1]++, 'white'))));
}))));
var SoldOutIndicator = (cov_4c1niri6z().s[10]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(Indicator).attrs({
  className: 'stx-SoldOutIndicator'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      background-color: ", ";\n      color: ", ";\n    "])), _stylingConstants.default.color.negative, _stylingConstants.default.color.baseBackground)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      ", ";\n    "])), function (props) {
  var _props$theme;
  cov_4c1niri6z().f[6]++;
  var msgErrorColor = (cov_4c1niri6z().s[11]++, (cov_4c1niri6z().b[9][0]++, (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.messageErrorTitleColor) || (cov_4c1niri6z().b[9][1]++, '#CC0000'));
  cov_4c1niri6z().s[12]++;
  return (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n          color: var(--messageErrorTitleColor, ", ");\n          background-color: var(--messageErrorBgColor, ", ");\n        "])), msgErrorColor, (0, _polished.rgba)(msgErrorColor, 0.05));
}))));
var ComingSoonIndicator = (cov_4c1niri6z().s[13]++, (0, _styledComponents.default)(AdvantageIndicator).attrs({
  className: 'stx-ComingSoonIndicator'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)([""]))));
var OutOfSaleIndicator = (cov_4c1niri6z().s[14]++, (0, _styledComponents.default)(AdvantageIndicator).attrs({
  className: 'stx-OutOfSaleIndicator'
})(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)([""]))));
var AdvantageIcon = (cov_4c1niri6z().s[15]++, (0, _styledComponents.default)(_icon.default).attrs({
  iconName: 'riStarSLine',
  size: 20
})(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 16px;\n  width: 20px;\n  height: 20px;\n"]))));

// Component that retrieve product and produce relevant indicator
cov_4c1niri6z().s[16]++;
var ProductIndicator = function ProductIndicator(_ref2) {
  var product = _ref2.product,
    performance = _ref2.performance,
    timeslot = _ref2.timeslot,
    hospitalitySession = _ref2.hospitalitySession,
    themeQueries = _ref2.themeQueries,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  cov_4c1niri6z().f[7]++;
  var _ref3 = (cov_4c1niri6z().s[17]++, product),
    advantages = _ref3.advantages;
  var availability = (cov_4c1niri6z().s[18]++, (0, _utils2.getAvailability)(product, performance, timeslot, hospitalitySession));

  // Define some values depending on the object we are working on
  var _ref4 = (cov_4c1niri6z().s[19]++, (cov_4c1niri6z().b[10][0]++, performance) || (cov_4c1niri6z().b[10][1]++, timeslot) || (cov_4c1niri6z().b[10][2]++, product)),
    notOnSales = _ref4.notOnSales,
    restrictedAdv = _ref4.restrictedAdv,
    salesEndDate = _ref4.salesEndDate;
  var id = (cov_4c1niri6z().s[20]++, (cov_4c1niri6z().b[11][0]++, performance) && (cov_4c1niri6z().b[11][1]++, performance.id) || (cov_4c1niri6z().b[11][2]++, timeslot) && (cov_4c1niri6z().b[11][3]++, timeslot.id) || (cov_4c1niri6z().b[11][4]++, hospitalitySession) && (cov_4c1niri6z().b[11][5]++, hospitalitySession.id) || (cov_4c1niri6z().b[11][6]++, product) && (cov_4c1niri6z().b[11][7]++, product.id));
  // The has advantage is not defined the same way
  var hasAdvantages;
  cov_4c1niri6z().s[21]++;
  if (performance) {
    cov_4c1niri6z().b[12][0]++;
    cov_4c1niri6z().s[22]++;
    hasAdvantages = performance.withAdvantage;
  } else {
    cov_4c1niri6z().b[12][1]++;
    cov_4c1niri6z().s[23]++;
    if (timeslot) {
      cov_4c1niri6z().b[13][0]++;
      cov_4c1niri6z().s[24]++;
      hasAdvantages = timeslot.withAdvantage;
    } else {
      cov_4c1niri6z().b[13][1]++;
      cov_4c1niri6z().s[25]++;
      hasAdvantages = (cov_4c1niri6z().b[14][0]++, (0, _isArray.default)(advantages)) && (cov_4c1niri6z().b[14][1]++, advantages.length > 0);
    }
  }
  var isSoldOut = (cov_4c1niri6z().s[26]++, (cov_4c1niri6z().b[15][0]++, availability === 'NONE') && (cov_4c1niri6z().b[15][1]++, !notOnSales));
  var isInFutureSalesPeriod = (cov_4c1niri6z().s[27]++, (cov_4c1niri6z().b[16][0]++, notOnSales) && (cov_4c1niri6z().b[16][1]++, !restrictedAdv));
  var isAvailableOnSales = (cov_4c1niri6z().s[28]++, (cov_4c1niri6z().b[17][0]++, !isSoldOut) && (cov_4c1niri6z().b[17][1]++, !notOnSales));
  var isOutOfSale = (cov_4c1niri6z().s[29]++, (cov_4c1niri6z().b[18][0]++, notOnSales) && (cov_4c1niri6z().b[18][1]++, (0, _utils2.isAfterSaleEnd)(salesEndDate)));
  var isAdvantageHasAvailability = (cov_4c1niri6z().s[30]++, (cov_4c1niri6z().b[19][0]++, advantages.find(function (adv) {
    cov_4c1niri6z().f[8]++;
    cov_4c1niri6z().s[31]++;
    return adv.availability !== 'NONE';
  })) || (cov_4c1niri6z().b[19][1]++, !isOutOfSale) && (cov_4c1niri6z().b[19][2]++, isInFutureSalesPeriod) || (cov_4c1niri6z().b[19][3]++, isOutOfSale) || (cov_4c1niri6z().b[19][4]++, restrictedAdv));
  cov_4c1niri6z().s[32]++;
  return (cov_4c1niri6z().b[20][0]++, hasAdvantages) && (cov_4c1niri6z().b[20][1]++, isAvailableOnSales) && (cov_4c1niri6z().b[20][2]++, /*#__PURE__*/_react.default.createElement(AdvantageIndicator, (0, _extends2.default)({
    id: id
  }, props, {
    hasAvailability: isAdvantageHasAvailability,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 9
    }
  }), (cov_4c1niri6z().b[21][0]++, themeQueries.EVOLUTION) && (cov_4c1niri6z().b[21][1]++, /*#__PURE__*/_react.default.createElement(AdvantageIcon, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 172,
      columnNumber: 38
    }
  })), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.advantageText",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 11
    }
  }))) || (cov_4c1niri6z().b[20][3]++, isSoldOut) && (cov_4c1niri6z().b[20][4]++, /*#__PURE__*/_react.default.createElement(SoldOutIndicator, (0, _extends2.default)({
    id: id
  }, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 177,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.soldOutText",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 178,
      columnNumber: 9
    }
  }))) || (cov_4c1niri6z().b[20][5]++, !isOutOfSale) && (cov_4c1niri6z().b[20][6]++, isInFutureSalesPeriod) && (cov_4c1niri6z().b[20][7]++, /*#__PURE__*/_react.default.createElement(ComingSoonIndicator, (0, _extends2.default)({
    id: id
  }, props, {
    hasAvailability: isAdvantageHasAvailability,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 183,
      columnNumber: 9
    }
  }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.comingSoon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 184,
      columnNumber: 11
    }
  }))) || (cov_4c1niri6z().b[20][8]++, isOutOfSale) && (cov_4c1niri6z().b[20][9]++, /*#__PURE__*/_react.default.createElement(OutOfSaleIndicator, (0, _extends2.default)({
    id: id
  }, props, {
    hasAvailability: isAdvantageHasAvailability,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 188,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.outOfSale",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 189,
      columnNumber: 9
    }
  }))) || (cov_4c1niri6z().b[20][10]++, restrictedAdv) && (cov_4c1niri6z().b[20][11]++, /*#__PURE__*/_react.default.createElement(AdvantageIndicator, (0, _extends2.default)({
    id: id
  }, props, {
    hasAvailability: isAdvantageHasAvailability,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 193,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.restrictedOffer",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 194,
      columnNumber: 9
    }
  }))) || (cov_4c1niri6z().b[20][12]++, null);
};
cov_4c1niri6z().s[33]++;
ProductIndicator.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* A specific timeslot to display, if provided take the timeslot data in priority */
  timeslot: _product.TimeslotType,
  /* A specific hospitality session to display, if provided take the hospitality session data in priority */
  hospitalitySession: _product.HospitalitySessionType,
  /* Define if the indicator has an absolute position or not */
  inline: _propTypes.default.bool,
  themeQueries: _utils.WithThemeQueriesType
};
cov_4c1niri6z().s[34]++;
ProductIndicator.defaultProps = {
  performance: null,
  timeslot: null,
  hospitalitySession: null,
  inline: false,
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(ProductIndicator));